import React from "react";
import { ToggleButton } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import useSWR from "swr";

import {
  getSettingState,
  setCategoryIdMain,
} from "../../../../redux/features/settingSlice";

const CategoryHeader = () => {
  const { categoryIdMain } = useSelector(getSettingState);
  const dispatch = useDispatch();
  const { userData } = useSelector(getSettingState);

  const { data: yourTable } = useSWR(
    process.env.REACT_APP_API + `/content/profile/owned-tables/${userData}/`,
    {
      dedupingInterval: 30000,
    }
  );
  const { data: participatedTable } = useSWR(
    process.env.REACT_APP_API + `/content/profile/participated-tables/${userData}/`,
    {
      dedupingInterval: 30000,
    }
  );
  const { data: enrolledTables } = useSWR(
    process.env.REACT_APP_API + `/content/profile/spectated-table/${userData}/`,
    {
      dedupingInterval: 30000,
    }
  );
  const { data: favoriteTables } = useSWR(
    process.env.REACT_APP_API + `/content/profile/favorite-tables/${userData}/`,
    {
      dedupingInterval: 30000,
    }
  );

  const categoryList = [
    {
      id: "owned-tables",
      name: "Your tables",
      data: yourTable?.results.length,
    },
    {
      id: "participated-tables",
      name: "Participated tables",
      data: participatedTable?.results.length,
    },
    {
      id: "spectated-table",
      name: "Followed tables",
      data: enrolledTables?.results.length,
    },
    {
      id: "favorite-tables",
      name: "Favorite tables",
      data: favoriteTables?.results.length,
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "white.main",
        marginBottom: "18px",
        overflowX: "scroll",
        whiteSpace: "nowrap",
        pt: "8px",
        pb: "8px",
        width: "104%",
        position: "sticky",
        top: -1,
        zIndex: 3,
      }}
    >
      {/* {isLoading &&
        Array(5)
          .fill("")
          .map((e, i) => {
            return (
              <Box
                key={i}
                sx={{
                  fontSize: "16px",
                  display: "inline-flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  color: "#7c7c7c",
                  pl: "0px !IMPORTANT",
                  height: "30px",
                  pr: "8px",
                }}
              >
                <Skeleton width={64} height={42} />
              </Box>
            );
          })} */}

      <Box
        onClick={() => dispatch(setCategoryIdMain(null))}
        sx={{
          border: "2px solid",
          display: "inline-flex",
          borderRadius: "6px",
          marginRight: "8px",
          height: "28px",
          borderColor: !categoryIdMain ? "black.main" : "#7c7c7c",
          backgroundColor: !categoryIdMain ? "black.main" : "",
        }}
      >
        <ToggleButton
          sx={{
            padding: "6px 8px 3px 8px",
            textTransform: "none",
            fontSize: "13px",
            lineHeight: "20px",
            border: "none",
            color: !categoryIdMain ? "white.main" : "#7c7c7c",
            "&.MuiButtonBase-root:hover": {
              backgroundColor: "rgba(0, 0, 0, 0)",
            },
          }}
          value='check'
        >
          {"All Tables"}
        </ToggleButton>
      </Box>

      {categoryList.map((row, i) => {
        return (
          <Box key={row.id} sx={{ display: "inline-flex" }}>
            {row.data ? (
              <Box
                onClick={() => dispatch(setCategoryIdMain(row.id))}
                sx={{
                  border: "2px solid ",
                  display: "inline-flex",
                  borderRadius: "6px",
                  marginRight: "8px",
                  height: "28px",
                  borderColor:
                    categoryIdMain === row.id ? "black.main" : "#7c7c7c",
                  backgroundColor:
                    categoryIdMain === row.id ? "black.main" : "",
                }}
              >
                <ToggleButton
                  sx={{
                    padding: "6px 8px 3px 8px",
                    textTransform: "none",
                    fontSize: "13px",
                    lineHeight: "20px",
                    border: "none",
                    color: categoryIdMain === row.id ? "white.main" : "#7c7c7c",
                    "&.MuiButtonBase-root:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0)",
                    },
                  }}
                  value='check'
                >
                  {row.name}
                </ToggleButton>
              </Box>
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
};

export default CategoryHeader;
